import {fromJS, Map} from 'immutable';
import averagePlayTimeActions from '../../actions/fortnite-game/averagePlayTime.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {TimeScale} from '../../types';

export interface AveragePlaytimeDataItem {
    day: string;
    creativeAccountId: string;
    creativeIslandCode: string;
    unique_users: number;
}

const DEFAULT_DATA = {
    [TimeScale.DAILY]: {
        list: [],
        empty: []
    },
    [TimeScale.WEEKLY]: {
        list: [],
        empty: []
    },
    [TimeScale.MONTHLY]: {
        list: [],
        empty: []
    }
};

export const DEFAULT_STATE = fromJS({
    data: DEFAULT_DATA,
    timeScale: TimeScale.DAILY,
    error: undefined,
    loading: false
});

export const averagePlayTimeReducer = (state: Map<string, any> = DEFAULT_STATE, action) => {
    const {timeScale, data, silent = false, error} = action.payload || {};

    switch (action.type) {
        case averagePlayTimeActions.TYPES.GET_AVERAGE_PLAY_TIME: {
            return state.merge({
                timeScale,
                error: undefined,
                loading: !silent
            });
        }

        case averagePlayTimeActions.TYPES.GET_AVERAGE_PLAY_TIME_COMPLETE: {
            return state
                .update('data', stateData => stateData.set(state.get('timeScale'), data))
                .merge({
                    lastFetch: Date.now(),
                    loading: false,
                    error
                });
        }

        case averagePlayTimeActions.TYPES.GET_AVERAGE_PLAY_TIME_FAILED: {
            return state.merge({
                error,
                loading: false
            });
        }

        case averagePlayTimeActions.TYPES.RESET_DATA: {
            return state.merge({
                data: DEFAULT_DATA
            });
        }

        default:
            return state;
    }
};

export default dieselReducer('averagePlayTime', averagePlayTimeReducer);
